<template>
  <div id="farmElement">
    <BlockDetails v-if="$store.state.drawer.blockDetails.show" />
    <BlockRevisions v-if="$store.state.drawer.blockRevisions.show" />
    <Collaborators v-if="$store.state.drawer.collaborators.show" />
    <Collectors v-if="$store.state.drawer.collectors.show" />
    <Collector v-if="$store.state.drawer.collector.show" />
    <CopyDataset v-if="$store.state.drawer.copyDataset.show" />
    <CreateDataset v-if="$store.state.drawer.createDataset.show" />
    <CreateFarm v-if="$store.state.drawer.createFarm.show" />
    <CreateBlockDrawer v-if="$store.state.drawer.createBlockDrawer.show" />
    <DataPointDetails v-if="$store.state.drawer.dataPointDetails.show" />
    <Datasets v-if="$store.state.drawer.datasets.show" />
    <DatasetDetails v-if="$store.state.drawer.datasetDetails.show" />
    <FarmDetails v-if="$store.state.drawer.farmDetails.show" />
    <FarmMap v-if="showMap" />
    <FirstFarmModal v-if="$store.state.display.modal.firstFarmModal" />
    <Key v-if="$store.state.showKey" />
    <Farms v-if="$store.state.drawer.farms.show"/>
    <FarmMenu />
    <Feedback />
    <!-- <Notifications /> -->
    <Plugins v-if="$store.state.drawer.plugins.show" />
    <PreviewBlockRevision v-if="$store.state.drawer.previewBlockRevision.show" />
    <PreviewRevision v-if="$store.state.drawer.previewRevision.show" />
    <Revisions v-if="$store.state.drawer.revisions.show" />
    <SatellitePanel v-if="$store.state.drawer.satellite.show" />
    <!-- <CreateDatasetDrawer v-if="$store.state.showCreateDatasetDrawer" /> -->
    <TermsModal
      v-if="showTerms"
      :updated="termsOfService.updated"
      :tosId="termsOfService.id"
      v-on:agreeToTerms="showTerms = false"
    />
    <ApiTokens v-if="$store.state.drawer.apiTokens.show" />
    <UserDetails v-if="$store.state.drawer.userDetails.show" />
    <UserSettings v-if="$store.state.drawer.userSettings.show" />
  </div><!-- /#farmElement -->
</template>

<script>
import BlockDetails from '../block/BlockDetails'
import BlockRevisions from '../block/BlockRevisions'
import Collaborators from './Collaborators'
import Collectors from '../collector/Collectors'
import Collector from '../collector/Collector'
import CreateDataset from '../dataset/CreateDataset'
import CreateFarm from './CreateFarm'
import CreateBlockDrawer from '../block/CreateBlockDrawer'
import CopyDataset from '../dataset/CopyDataset'
import DatasetDetails from '../dataset/DatasetDetails'
import Datasets from '../dataset/Datasets'
import DataPointDetails from '../collector/DataPointDetails'
import FarmDetails from './FarmDetails'
import FarmMap from './FarmMap'
import Farms from './Farms'
import FarmMenu from './FarmMenu'
import Feedback from '../user/Feedback'
import FirstFarmModal from './FirstFarmModal'
import Key from './Key'
// import Notifications from '../user/Notifications'
import Plugins from '../plugins/Plugins'
import PreviewBlockRevision from '../block/PreviewBlockRevision'
import PreviewRevision from '../collector/PreviewRevision'
import Revisions from '../collector/Revisions'
import SatellitePanel from '../plugins/satellite/SatellitePanel'
import TermsModal from '../user/TermsModal'
import ApiTokens from '../user/ApiTokens'
import UserDetails from '../user/UserDetails'
import UserSettings from '../user/UserSettings'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      showMap: false,
      showTerms: false,
      termsOfService: {
        updated: '1/5/2021',
        id: '1-5-2021' // Be sure to save the old version for future reference. Agreement currently written in TermsModal component
      }
    }
  },
  components: {
    ApiTokens,
    BlockDetails,
    BlockRevisions,
    CreateDataset,
    CreateFarm,
    CreateBlockDrawer,
    Collaborators,
    Collectors,
    Collector,
    CopyDataset,
    Datasets,
    DataPointDetails,
    DatasetDetails,
    FarmDetails,
    FarmMap,
    Farms,
    FarmMenu,
    Feedback,
    FirstFarmModal,
    Key,
    // Notifications,
    Plugins,
    PreviewBlockRevision,
    PreviewRevision,
    Revisions,
    SatellitePanel,
    TermsModal,
    UserDetails,
    UserSettings
  },
  created () {
    // this.$store.commit('resetDrawers')
    const self = this
    // Make sure we have a userProfile before initiating the farm
    function userProfileLoaded () {
      setTimeout(() => {
        if (Object.keys(self.$store.state.userProfile).length > 0) {
          self.initFarm()
        } else {
          userProfileLoaded()
        }
      }, 100)
    }
    userProfileLoaded()
  },
  methods: {
    initFarm () {
      if (this.$store.state.userProfile.tosId !== this.termsOfService.id) {
        this.showTerms = true
      }
      let farmId = this.$route.params.id
      // Rehydrate super-admin role simulation from the URL (?simAs=Role).
      // Keeping the simulated role in the URL — rather than only in memory —
      // means it survives a full page load: hard refresh, a directly-typed
      // /f/<id> link, or the Farms-Map popup opening a new tab. Without this
      // the simulation silently drops and fetchFarm falls back to the user's
      // real role. UI-only; backend rules still enforce real permissions.
      const simAs = this.$route.query.simAs
      if (simAs && farmId) {
        this.$store.commit('setStateProperty', {
          property: 'simulation',
          value: { active: true, role: simAs, farmId: farmId, farmName: '' }
        })
      }
      if (!farmId || farmId === 'undefined' || farmId === 'false') {
        if (this.$store.state.userProfile.defaultFarm !== 'undefined') {
          farmId = this.$store.state.userProfile.defaultFarm
          this.$router.push('/f/' + farmId)
        }
      }
      this.$store.dispatch('fetchFarms').then(() => {
        const farms = this.$store.state.farms || []
        const simulating = !!this.$route.query.simAs
        // Only load a farm the user can actually access. A stale defaultFarm
        // (or a hand-typed /f/<id>) pointing at a farm the user was removed
        // from must NOT be loaded — every dataset/block read would be denied
        // and the app would wedge on a farm it can't render. Super-admin
        // simulation (?simAs) is exempt: it intentionally views non-member
        // farms (and the backend honors the super-admin's real access).
        const hasAccess = simulating || farms.some(f => f.id === farmId)
        if (!farmId || farmId === 'undefined' || farmId === 'false' || !hasAccess) {
          if (farms[0]) {
            const fallbackId = farms[0].id
            // Self-heal a stale defaultFarm so the bad redirect doesn't recur.
            if (!simulating &&
                this.$store.state.userProfile.defaultFarm &&
                this.$store.state.userProfile.defaultFarm !== fallbackId) {
              fb.usersCollection.doc(this.$store.state.currentUser.uid)
                .update({ defaultFarm: fallbackId }).catch(() => {})
            }
            farmId = fallbackId
            this.$router.push('/f/' + farmId)
          } else {
            // No accessible farms at all — show the create-first-farm flow
            // and stop the chain (don't try to load a farm that isn't there).
            this.$store.commit('toggleModal', 'firstFarmModal')
            return Promise.reject(new Error('NO_ACCESSIBLE_FARM'))
          }
        }
        return this.$store.dispatch('fetchFarm', farmId)
      }).then(() => {
        return this.$store.dispatch('fetchDatasets', farmId)
      }).then(() => {
        return this.$store.dispatch('fetchFolders', farmId)
      }).then(() => {
        return this.$store.dispatch('fetchCollectors', farmId)
      }).then(() => {
        this.showMap = true
        return true
      }).then(() => {
        const self = this
        setTimeout(function () {
          return self.checkRoutes()
        }, 5000)
      }).catch(err => {
        // Expected control-flow signal when the user has no accessible farms
        // (we've already shown the create-first-farm modal) — not an error.
        if (err && err.message === 'NO_ACCESSIBLE_FARM') return
        console.log(err)
      })
    },
    checkRoutes () {
      if (this.$route.params.layerType === 'dataset') {
        this.$store.dispatch('removeAllLayers')
        fb.datasetsCollection.doc(this.$route.params.layerId).get().then(snapshot => {
          const datasetDoc = snapshot.data()
          datasetDoc.id = snapshot.id
          this.$store.commit('setDataset', datasetDoc)
          setTimeout(() => {
            // this.$store.dispatch('mapDataset', datasetDoc)
            this.$store.dispatch('launchDataset', { dataset: datasetDoc })
          }, 1000)
        })
      } else if (this.$route.params.layerType === 'block') {
        this.$store.commit('hideAllDrawers')
        // Get block data and open block drawer
        fb.blocksCollection.doc(this.$route.params.layerId).get().then(doc => {
          const blockDoc = doc.data()
          blockDoc.id = doc.id
          this.$store.commit('setStateProperty', { property: 'block', value: blockDoc })
          setTimeout(() => {
            // Add highlighted block layer
            if (this.$store.state.mapObject.getLayer('blockHighlightLayer')) {
              this.$store.state.mapObject.removeLayer('blockHighlightLayer')
              this.$store.state.mapObject.removeSource('blockHighlightLayer')
            }
            this.$store.state.mapObject.addLayer({
              id: 'blockHighlightLayer',
              type: 'fill',
              source: {
                type: 'geojson',
                data: JSON.parse(blockDoc.footprint)
              },
              layout: {},
              paint: {
                'fill-color': '#ffc107',
                'fill-opacity': 0.8
              }
            })
            const bounds = new mapboxgl.LngLatBounds() // eslint-disable-line
            JSON.parse(blockDoc.footprint).features.forEach(feature => {
              // For polygon geometries, coordinates[0] is the outer ring
              // We need to extend bounds with each [lng, lat] pair in the ring
              feature.geometry.coordinates[0].forEach(coord => {
                bounds.extend(coord)
              })
            })
            this.$store.state.mapObject.fitBounds(bounds, {
              padding: 50,
              animate: false
            })
            this.$store.commit('showDrawer', 'blockDetails')
          }, 300)
        }).catch(err => {
          console.log(err.message)
        })
      }
    }
  }
}
</script>

<style scoped>
#farmElement {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>
